<template>
  <tbody>
    <tr v-for="(rowMater,index) in row.materialGroup" :key="index" :style="{'background-color':row.markCodes.length>1?colors[row.markCodes.indexOf(rowMater.marketCode)]:'#fff'}">
      <td v-if="index==0" class=" is-center" :rowspan="row.materialGroup.length" style="background-color: #fff">
        {{ row.productSalesCode }}
      </td>
      <td v-if="index==0" class=" is-center" :rowspan="row.materialGroup.length" style="background-color: #fff">
        {{ row.productName }}
      </td>
      <td v-if="index==0" class=" is-center" :rowspan="row.materialGroup.length" style="background-color: #fff">
        <!-- {{ row.havePowerCord ? '是':'否' }} -->
        {{ row.powerCordSpecificationZh }}
      </td>
      <td class=" is-center" :class="{ active: rowMater.isSpecial }">
        <el-radio v-model="row.selected" class="material-code-main" :label="rowMater.materialCode" @change="()=>{row.materialUnit=rowMater.materialUnit}">
          {{ rowMater.materialCode }}
        </el-radio>
      </td>
      <td class=" is-center" style="background-color: #fff">
        <span v-if="rowMater.isMaster">是</span>
      </td>
      <td class=" is-center" :class="{ active: rowMater.isSpecial }">
        {{ rowMater.materialDesc }}
      </td>

      <!-- TODO -->
      <td class=" is-center" :class="{ active: rowMater.isSpecial }">
        {{ rowMater.marketName }}
      </td>
      <td class=" is-center" :class="{ active: rowMater.isSpecial }">
        {{ rowMater.itemOrderType }}
      </td>
      <td class=" is-center" :class="{ active: rowMater.isSpecial }">
        {{ rowMater.overseasProductModel }}
      </td>

      <td v-if="index==0" class=" is-center" :rowspan="row.materialGroup.length" style="background-color: #fff">
        {{ row.productNum }}
      </td>
      <td class=" is-center">
        {{ rowMater.amountOfStock }}
      </td>
      <td class=" is-center">
        <!--        <template v-for="(date,indexD) in rowMater.orders">-->
        <!--          {{ date.plannedCompletionTime }} /  {{ date.materialNum }}-->
        <!--          <br :key="indexD">-->
        <!--        </template>-->
        {{ rowMater.accumulatedAmount }}
      </td>
      <td class=" is-center">
        {{ rowMater.materialStatus }}
      </td>
      <td class=" is-center">
        {{ rowMater.abcClass }}
      </td>
      <td class=" is-center">
        {{ rowMater.itemSelectType }}
      </td>
      <td class=" is-center">
        {{ rowMater.remark }}
      </td>
    </tr>
  </tbody>
</template>
<script type="es6">
export default {
  data () {
    return {
      markCodes: [],
      colors: ['#F5CEC7', '#e79796', '#ffc988', '#d9ecf2', '#c6c09c', '#CCABDB', '#e1c0db', '#f1cfe5', '#ffb284', '#6ec6ca', '#f56a79']
    };
  },
  props: {
    row: {
      type: Object,
      default: () => { return {}; }
    },
    defvalue: {
      type: Object,
      default: () => { return {}; }
    },
    tgColor: {
      type: [String, Number],
      default: ''

    }
  },
  components: {},
  computed: {},
  methods: {},
  created () {
    if (this.row.materialGroup.length === 1) {
      this.$set(this.row, 'selected', this.row.materialGroup[0].materialCode);
      this.$set(this.row, 'materialUnit', this.row.materialGroup[0].materialUnit);
    }
    // if (this.defvalue.materialNumberId) {
    //   this.$set(this.row, 'selected', this.defvalue.materialNumberId);
    //   this.$set(this.row, 'materialUnit', this.defvalue.materialUnit);
    // }
    this.row.materialGroup.forEach((item) => {
      if (!this.row.markCodes) {
        this.$set(this.row, 'markCodes', []);
      }
      if (item.marketCode && this.row.markCodes.indexOf(item.marketCode) < 0) {
        this.row.markCodes.push(item.marketCode);
      }
      if (item.isChecked) {
        this.$set(this.row, 'selected', item.materialCode);
        this.$set(this.row, 'materialUnit', item.materialUnit);
      }
    });
  }
};
</script>
<style lang="scss">
  .active{
    background: #FF9D9D;
  }
</style>

<style lang="scss" scoped>
.material-code-main{
  ::v-deep .el-radio__label {
    padding-left: 0;
  }
}
</style>
